export default function Marquee({ items, className = "" }) {
  const content = items.map((t, i) => (
    <span key={i} className="flex items-center shrink-0">
      <span className="font-sans font-light italic tracking-wide text-jm-bone/70 text-sm sm:text-base px-6">{t}</span>
      <span className="text-jm-amber text-xs">◆</span>
    </span>
  ));
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y border-jm-brass/15 py-5 select-none ${className}`}
      aria-hidden="true"
    >
      <div className="jm-marquee-track flex w-max">
        <div className="flex">{content}</div>
        <div className="flex">{content}</div>
      </div>
    </div>
  );
}
